<template>
  <div>
    <div class="regra-produto-card">
      <div class="regra-tipo-badge">Produto</div>
      <div class="regra-section-label">Regra de validação</div>

      <div class="regra-produto-container">
        <DropdownInput
            :value="dimensaoCampanha.idProd"
            label="PRODUTO"
            hint="Utilize este campo para selecionar produtos individuais (avulsos) que farão parte desta regra."
            field="idProd"
            :index="index"
            @input="updateField(index, 'idProd', $event, dimensaoCampanha, 'idProdAplicacao')"
        />
        <DropdownInput
            :value="dimensaoCampanha.idProdPrincipal"
            label="PRODUTO PRINCIPAL"
            hint="Utilize este campo para buscar produtos vinculados a um produto principal (estrutura pai/filho). Não utilize este campo para selecionar produtos avulsos."
            field="idProdPrincipal"
            :index="index"
            @input="updateField(index, 'idProdPrincipal', $event, dimensaoCampanha, 'idProdPrincipalAplicacao')"
        />
      </div>

      <hr class="regra-divider" />

      <div class="regra-section-label">Regra de aplicação</div>
      <div class="regra-aplicacao-check">
        <label>
          <input
              type="checkbox"
              v-model="dimensaoCampanha.aplicaregra"
              :value="true"
              @change="clonarRegra(dimensaoCampanha)"
              :disabled="campanha.erpId && campanha.id"
          />
          Aplicar o desconto nos mesmos itens da regra de validação
        </label>
      </div>

      <div class="regra-produto-container">
        <DropdownInput
            :value="getValueAplicacao('idProd', 'idProdAplicacao', dimensaoCampanha)"
            label="PRODUTO"
            hint="Utilize este campo para selecionar produtos individuais (avulsos) que farão parte desta regra."
            field="idProdAplicacao"
            :index="index"
            :disabled="!!dimensaoCampanha.aplicaregra"
            @input="updateField(index, 'idProdAplicacao', $event, dimensaoCampanha)"
        />
        <DropdownInput
            :value="getValueAplicacao('idProdPrincipal', 'idProdPrincipalAplicacao', dimensaoCampanha)"
            label="PRODUTO PRINCIPAL"
            hint="Utilize este campo para buscar produtos vinculados a um produto principal (estrutura pai/filho). Não utilize este campo para selecionar produtos avulsos."
            field="idProdPrincipalAplicacao"
            :index="index"
            :disabled="!!dimensaoCampanha.aplicaregra"
            @input="updateField(index, 'idProdPrincipalAplicacao', $event, dimensaoCampanha)"
        />
      </div>

      <div v-if="campanha.validarPorRegra">
        <TipoValidacao
            :item="dimensaoCampanha"
            :inputShouldBeVisible="inputShouldBeVisible"
            :validacao="validacao"
            :disabled="campanha.erpId && campanha.id"
        />
      </div>

      <div class="regra-footer">
        <div class="regra-footer__desc-input">
          Desconto de
          <input
              type="number"
              min="0"
              step="0.01"
              v-model="dimensaoCampanha.percDesc"
              @keydown="['-', 'e', 'E', '+'].includes($event.key) && $event.preventDefault()"
              :disabled="campanha.erpId && campanha.id"
          />
          % nos itens da regra de aplicação
        </div>
        <button
            type="button"
            class="regra-footer__delete"
            @click="excluirRegra(index)"
            :disabled="campanha.erpId && campanha.id"
        >
          <CIcon name="cil-trash" size="sm" /> Excluir
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DropdownInput from '../DropdownInput.vue';
import TipoValidacao from "@/views/Campanhas/components/CampanhasComerciais/components/Regra/TipoValidacao.vue";

export default {
  components: { DropdownInput, TipoValidacao },
  props: ['campanha', 'dimensaoCampanha', 'validacao', 'tiposInputs', 'index'],
  methods: {
    excluirRegra(index) {
      this.campanha.dimensoes.splice(index, 1);
    },
    inputShouldBeVisible(inputName) {
      return (
          this.tiposInputs[this.campanha.validacao] &&
          this.tiposInputs[this.campanha.validacao].indexOf(inputName) >= 0
      );
    },
    clonarRegra(regraProduto) {
      if (regraProduto.aplicaregra) {
        regraProduto.idProdAplicacao = regraProduto.idProd;
        regraProduto.idProdPrincipalAplicacao = regraProduto.idProdPrincipal;
      }
    },
    updateField(index, field, value, regraProduto, mirrorField = null) {
      this.$set(this.campanha.dimensoes[index], field, value);

      if (regraProduto.aplicaregra && mirrorField) {
        this.$set(this.campanha.dimensoes[index], mirrorField, value)
      }
    },
    getValueAplicacao(validacaoField, aplicacaoField, regraProduto) {
      if (regraProduto.aplicaregra) {
        return regraProduto[validacaoField];
      }

      return regraProduto[aplicacaoField];
    }
  }
};
</script>

<style scoped>
.regra-produto-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fff;
}

.regra-tipo-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f2f2f8;
  color: #3a3e81;
  margin-bottom: 12px;
}

.regra-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.regra-produto-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
  position: relative;
  margin-bottom: 16px;
}

.regra-aplicacao-check {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.regra-aplicacao-check label {
  font-size: 12px;
  color: #555;
  cursor: pointer;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.regra-aplicacao-check input[type="checkbox"] {
  accent-color: #3a3e81;
}

.regra-divider {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 14px 0;
}

.regra-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  margin-top: 12px;
}

.regra-footer__desc-input {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #555;
}

.regra-footer__desc-input input {
  width: 64px;
  text-align: right;
  border: 1px solid #dddce9;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 600;
}

.regra-footer__desc-input input:focus {
  border-color: #3a3e81;
  outline: none;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.regra-footer__delete {
  background: none;
  border: 1px solid #e4e7eb;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s ease;
}

.regra-footer__delete:hover {
  border-color: #e74c3c;
  color: #e74c3c;
  background: #fef2f2;
}

.dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  z-index: 1000;
  border: 1px solid #dddce9;
  border-radius: 6px;
}

.dropdown-item {
  padding: 10px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}
</style>
